import { Dimensions } from './component-dimensions.constants';

export function computePaddingTop(dimensions: Dimensions) {
  return (dimensions.height / dimensions.width) * 100;
}
